import React from 'react';
import { DatePicker, Icon, InputCheckbox, Tooltip } from 'ui';

/**
 * PublishScoreSection - sección "Publicación de notas" compartida por los formularios
 * de actividad/quiz (NewActivity y NewTestForm). Extraída para evitar duplicación (TAN-8037).
 */

type PublishScoreTest = {
  autoPublishScore?: boolean;
  publish_score_at?: string | Date | null;
  sameAsDueDate?: boolean;
  dueDate?: string | Date | null;
};

interface PublishScoreSectionProps {
  readonly t: (key: string) => string;
  readonly rootClassName: string;
  readonly classPrefix: string;
  readonly test: PublishScoreTest;
  readonly disabled?: boolean;
  readonly hasPublishScoreBeforeDueDate?: boolean;
  readonly onToggleAutoPublishScore: () => void;
  readonly onChangePublishScoreAt: (date: Date | null) => void;
  readonly onClearPublishScoreAt: () => void;
  readonly onToggleSameAsDueDate: () => void;
}

function PublishScoreSection({
  t,
  rootClassName,
  classPrefix,
  test,
  disabled = false,
  hasPublishScoreBeforeDueDate = false,
  onToggleAutoPublishScore,
  onChangePublishScoreAt,
  onClearPublishScoreAt,
  onToggleSameAsDueDate,
}: PublishScoreSectionProps): JSX.Element {
  return (
    <div className={rootClassName}>
      <div className={`${classPrefix}-header`}>
        <span className={`${classPrefix}-title`}>{t('assigments:Grade publication')}</span>
        <Tooltip title={t('assigments:Grade publication tooltip')} placement="top" hasArrow>
          <span className={`${classPrefix}-info`}>
            <Icon name="info-circle" size="sm" />
          </span>
        </Tooltip>
      </div>
      <InputCheckbox
        checked={test.autoPublishScore}
        disabled={disabled}
        label={t('assigments:Automatic grade publication')}
        onChange={onToggleAutoPublishScore}
      />
      {test.autoPublishScore && (
        <div className={`${classPrefix}-date`}>
          <DatePicker
            isNonModal
            label={t('assigments:Publication date')}
            minDate={test.dueDate}
            onChange={onChangePublishScoreAt}
            onClear={onClearPublishScoreAt}
            shouldDisablePast
            showHour
            value={test.publish_score_at}
          />
          <InputCheckbox
            checked={test.sameAsDueDate}
            disabled={!test.dueDate}
            label={t('assigments:Same as due date')}
            onChange={onToggleSameAsDueDate}
          />
          {hasPublishScoreBeforeDueDate && (
            <span className={`${classPrefix}-error`}>{t('assigments:Publication date must be after due date')}</span>
          )}
        </div>
      )}
    </div>
  );
}

export default PublishScoreSection;
